import React, { useEffect } from 'react';

type PersonnelToastProps = {
    message: string;
    color?: string;
    duration?: number;
    onClose: () => void;
    persistent?: boolean;
};

const PersonnelToast: React.FC<PersonnelToastProps> = ({
    message,
    color = 'rgba(0,150,0,0.5)',
    duration = 3000,
    onClose,
    persistent = false
}) => {
    useEffect(() => {
        if (!persistent) {
            const timer = setTimeout(() => {
                onClose();
            }, duration);

            return () => clearTimeout(timer);
        }
        
        return undefined;
    }, [duration, onClose]);

    return (
        <div
            style={{
                top: '2.5rem',
                left: '0',
                width: '100%',
                height: '3rem',
                color: 'white',
                backgroundColor: color,
                zIndex: 9000,
                padding: '1rem 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <div>{message}</div>
        </div>
    );
};

export default PersonnelToast;



// WEBPACK FOOTER //
// ./src/components/personnel/components/PersonnelToast.tsx